import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';
import { getRelatedItems } from '../api';
import ListingImage from './ListingImage';
import StarRating from './StarRating';

// fix_issue3.md #7 - "You may also like", shown below a listing's detail.
// homepage/user_experience.md #2 - at least 4 listings, with a way to keep browsing more.
export default function RelatedItems({ itemId, category }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let cancelled = false;
    getRelatedItems(itemId)
      .then((data) => { if (!cancelled) setItems(data || []); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [itemId]);

  if (items.length === 0) return null;

  const moreHref = category ? `/?category=${encodeURIComponent(category)}` : '/';

  return (
    <div className="mt-5">
      <div className="d-flex justify-content-between align-items-baseline mb-3">
        <h5 className="mb-0">You may also like</h5>
        <Link to={moreHref} className="small">See more like this &rarr;</Link>
      </div>
      <Row xs={2} sm={3} lg={4} className="g-3">
        {items.map((item) => (
          <Col key={item._id}>
            <Link to={`/items/${item._id}`} className="text-decoration-none text-dark">
              <div className="border rounded h-100 overflow-hidden bg-white">
                {item.images?.[0] && (
                  <ListingImage
                    src={item.images[0]}
                    alt={item.name}
                    sizes="(max-width: 768px) 50vw, 200px"
                    style={{ width: '100%', height: 120, objectFit: 'cover' }}
                  />
                )}
                <div className="p-2">
                  <div className="small fw-semibold text-truncate">{item.name}</div>
                  <div className="small">₹{item.price}/{item.priceUnit}</div>
                  {item.ratingCount > 0 && <StarRating value={item.ratingAvg} count={item.ratingCount} />}
                </div>
              </div>
            </Link>
          </Col>
        ))}
      </Row>
    </div>
  );
}
